import React from 'react';

export default function Footer(): JSX.Element {
  return (
    <div className="pt-3 pb-3 mx-2 md:pb-3 text-sm text-gray-400 flex flex-row justify-center text-center items-center">
      This service is provided on a best-effort basis by the TOSG team. No
      guarantees on service uptime and availability or data integrity is
      provided. No personal data is collected or used in anyway; each checklist is only tagged to the URL.
    </div>
  );
}
